// extracted by mini-css-extract-plugin
export default {"content":"Confirm_content__6b4C0"};